import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import authService from '../../api/authService';
import { removeApiKey, removeTeamEmail, removeToken, setApiKey, setTeamEmail } from '../../Utility/Utility';

const pagePathMap = {
  dashboard: '/',
  customers: '/customers',
  products: '/products',
  quotes: '/quotations',
  subscriptions: '/subscriptions',
  invoices: '/invoices',
  feedback: '/billing/feedback',
  settings: '/settings',
    logs: '/system-logs'
};

const EmbedEntryPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const openEmbed = async () => {
      const searchParams = new URLSearchParams(location.search);
      const apiKey = searchParams.get('apiKey');
      const page = searchParams.get('page') || '';
      const teamEmail = searchParams.get('teamEmail') || '';

      removeToken();
      removeApiKey();
      removeTeamEmail();

      if (apiKey) {
        setApiKey(apiKey);
      }

      if (teamEmail) {
        setTeamEmail(teamEmail);
      }

      let resolvedPage = page;

      if (!resolvedPage && apiKey) {
        try {
          const meRes = await authService.me();
          const allowedPages = meRes?.userInfo?.permissions?.allowedPages || [];
          resolvedPage = allowedPages[0] || 'customers';
        } catch (error) {
          resolvedPage = 'customers';
        }
      }

      const targetPath = pagePathMap[resolvedPage] || '/customers';
      navigate(targetPath, { replace: true });
    };

    openEmbed();
  }, [location.search, navigate]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status"></div>
        <div className="fw-600">Opening embedded billing page...</div>
      </div>
    </div>
  );
};

export default EmbedEntryPage;
